import React from 'react';

import styles from './ModalMoreInfoPackage.module.scss';
import {moreInfoPackage} from "../../../constants/moreInfoPackage";

const ModalMoreInfoPackage = ({setIsModalMoreInfoPackageOpen}) => {
    return (
        <div
            onClick={() => setIsModalMoreInfoPackageOpen(false)}
            className={styles.modalMoreInfoPackage_wrapper}
        >
            <div className={styles.modalMoreInfoPackage_wrapper_modalMoreInfoPackage}>
                {
                    moreInfoPackage.map((item, index) => {
                        return <div className={styles.modalMoreInfoPackage_wrapper_modalMoreInfoPackage_block}>
                            <h2 className={styles.title}>{item.title}</h2>
                            <ul className={styles.list}>
                                {item.description.map((item, index) => <li key={index}>{item}</li>)}
                            </ul>
                        </div>
                    })
                }
            </div>
        </div>
    );
};

export default ModalMoreInfoPackage;